import { MessageSquare } from "lucide-react";

/**
 * Vertical right-edge tab that opens the RT-summary panel. Styled to
 * match ``RTScheduleFab``, ``ZohoNotesBlock``, ``CloseAtendimentoBlock``
 * and ``CalendarFab`` — same rounded-l-2xl, py-4 px-2, vertical text
 * layout — but anchored between AGENDAR RT and ZOHO.
 *
 * Só é útil depois da RT concluída — o próprio LeadDetail já garante
 * o render conditional. Ao clicar dispara ``window.dispatchEvent
 * ("open-rt-summary")`` — o LeadDetail intercepta, força a abertura
 * do painel (mesmo passada a janela de 60 min) e faz scroll para lá.
 *
 * Se o resumo já foi enviado (``rt_summary_sent_at``), o ícone
 * ganha um pequeno pin verde no canto (não ocupa espaço extra no
 * rail — mantém o alinhamento vertical dos restantes botões).
 */
export default function RTSummaryFab({ lead }) {
  const sent = !!lead?.rt_summary_sent_at;
  const handleClick = () => {
    window.dispatchEvent(new CustomEvent("open-rt-summary", { detail: { id: lead?.id } }));
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="rt-summary-fab"
      title={sent ? "Resumo RT já enviado — abrir para consultar" : "Enviar resumo da RT para o ClickUp"}
      aria-label="Resumo RT para o ClickUp"
      className="fixed top-[calc(50%-140px)] right-0 z-40 flex flex-col items-center gap-2 py-4 px-2 rounded-l-2xl bg-card border border-r-0 border-border shadow-[0_10px_40px_-10px_rgba(15,27,44,0.14)] hover:bg-muted transition-colors group"
    >
      <span className="relative inline-flex">
        <MessageSquare className="w-4 h-4 text-primary group-hover:scale-110 transition-transform" />
        {sent && (
          <span
            aria-hidden
            className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-[hsl(var(--success))] ring-2 ring-card"
            title="Já enviado"
          />
        )}
      </span>
      <span className="[writing-mode:vertical-rl] rotate-180 text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground group-hover:text-foreground">
        Resumo RT
      </span>
    </button>
  );
}
